export default __webpack_public_path__ + "static/SaolDisplay-Regular-83fe2fef8db9e3cb84a007d1f94793f9.woff";